import PopperComponent from './Popper.component';

export default PopperComponent;